var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "back",
      class: { fixed: _vm.isFixed, hide: _vm.isHide },
      style: { "--fontColor": _vm.fontColor, "--bgColor": _vm.bgColor },
      on: { click: _vm.clickEvent },
    },
    [_c("i", { staticClass: "iconfont icon-arrow-left" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }